export interface PurchaseInvoiceEmailContacts {
  id: string;
  emailInvoice: boolean;
  supplierInvoiceEmailAddress: string;
  purchaseInvoiceContactEmailAddress: string;
}
